import { render, staticRenderFns } from "./ComprobanteCanje.vue?vue&type=template&id=736fcab7&scoped=true&"
import script from "./ComprobanteCanje.vue?vue&type=script&lang=js&"
export * from "./ComprobanteCanje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fcab7",
  null
  
)

export default component.exports